export const getAuthString = (nickName: string, otpAuthSecretCode: string) => {
    if (!nickName) {
        return "";
    }
    return `otpauth://totp/DeMasterCRM${nickName}?secret=${otpAuthSecretCode}`;
};
